/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Rationale_CheckinInputs */

const en_us2_push_rationale_checkin = /** @type {(inputs: Push_Rationale_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A check-in the next morning, to see how your body took it.`)
};

const pt_br2_push_rationale_checkin = /** @type {(inputs: Push_Rationale_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um check-in na manhã seguinte, para saber como o corpo reagiu.`)
};

const es_419_push_rationale_checkin = /** @type {(inputs: Push_Rationale_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un check-in a la mañana siguiente, para saber cómo reaccionó tu cuerpo.`)
};

const pt_pt2_push_rationale_checkin = /** @type {(inputs: Push_Rationale_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um check-in na manhã seguinte, para saber como o corpo reagiu.`)
};

const fr_fr2_push_rationale_checkin = /** @type {(inputs: Push_Rationale_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un bilan le lendemain matin, pour savoir comment ton corps a réagi.`)
};

const de_de2_push_rationale_checkin = /** @type {(inputs: Push_Rationale_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Check-in am nächsten Morgen, um zu sehen, wie dein Körper es verkraftet hat.`)
};

const it_it2_push_rationale_checkin = /** @type {(inputs: Push_Rationale_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un check-in la mattina dopo, per sapere come ha reagito il corpo.`)
};

/**
* | output |
* | --- |
* | "A check-in the next morning, to see how your body took it." |
*
* @param {Push_Rationale_CheckinInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_rationale_checkin = /** @type {((inputs?: Push_Rationale_CheckinInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Rationale_CheckinInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_rationale_checkin(inputs)
	if (locale === "es-419") return es_419_push_rationale_checkin(inputs)
	if (locale === "pt-PT") return pt_pt2_push_rationale_checkin(inputs)
	if (locale === "fr-FR") return fr_fr2_push_rationale_checkin(inputs)
	if (locale === "de-DE") return de_de2_push_rationale_checkin(inputs)
	if (locale === "it-IT") return it_it2_push_rationale_checkin(inputs)
	return en_us2_push_rationale_checkin(inputs)
});
export { push_rationale_checkin as "push.rationale_checkin" }